import {
  ROLE_FIND_ALL,
  ROLE_SET_INITIAL_STATE,
  ROLE_VIEW
} from './roleTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ROLE_SET_INITIAL_STATE:
      return initialState;
    case ROLE_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case ROLE_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
